import * as model from './model'
export { model }
import reducer from './reducer'
export default reducer



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/store/persist/index.ts